function Plane() {
  return (
    <svg width="19" height="15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M3.701 2.008l1.343-.824 6.354 1.81-3.645 2.238-4.052-3.224zm.49 6.362l4.236-2.6 4.029-2.474 3.357-2.062c.885-.55 2.402-.52 2.79.192.386.712-.363 2.12-1.24 2.665l-3.357 2.06-1.986 7.885-1.343.825-.7-6.236-4.235 2.601-.764 2.373-.94.577-.549-3.47L.938 8.463l.939-.577 2.314.483z" fill="currentColor"
      />
    </svg>
  )
}

export default function AirportsList({ list, select, highlightedIndex }) {
  if (!list.length) {
    return null
  }

  return (
    <ul className="ul-px-20 md:ul-p-0">
      {list.map((item, index) => (
        <li
          key={index}
          {...(item.getItemProps
            ? item.getItemProps({
                onClick: select
                  ? () => {
                      select(item)
                    }
                  : undefined,
              })
            : select
            ? {
                onClick: () => {
                  select(item)
                },
              }
            : {})}
          className={`ul-flex ul-justify-between ul-items-center ul-px-0 ul-py-20 md:ul-p-20 ul-border-b last:ul-border-b-0 ul-border-dark-10 ul-w-full ul-text-left hover:ul-bg-dark-10 ul-cursor-pointer ${
            index === highlightedIndex ? 'ul-bg-dark-10' : ''
          }`}
        >
          <div className="ul-flex ul-items-center">
            {item.type === 'airport' ? (
              <div className="ul-mr-10 ul-opacity-60">
                <Plane />
              </div>
            ) : null}
            <div>
              <p className="ul-text-base">{item.label}</p>
              <p className="ul-text-14">{item.subLabel}</p>
            </div>
          </div>
          <p className="ul-text-14">{item.value}</p>
        </li>
      ))}
    </ul>
  )
}
